// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 22 13" {...rest} unit={unit}>
		<g transform="translate(-20.000000, -24.000000)" fill="#C0C0C0">
			<path d="M28.7053571,26.7142857 L23.3660714,26.7142857 L23.3660714,29.3125
			L28.2053571,29.3125 L28.2053571,32.0089286 L23.3660714,32.0089286 L23.3660714,37
			L20,37 L20,24 L28.7053571,24 L28.7053571,26.7142857 Z M38.0803571,37
			L37.3928571,34.7857143 L33.2410714,34.7857143 L32.5535714,37 L28.9553571,37
			L33.7410714,24 L36.875,24 L41.6875,37 L38.0803571,37 Z M34.0803571,32.0803571
			L36.5446429,32.0803571 L35.3125,28.1160714 L34.0803571,32.0803571 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/FA.js